import { render, staticRenderFns } from "./user-management-details.vue?vue&type=template&id=3817dede&scoped=true&"
import script from "./user-management-details.vue?vue&type=script&lang=js&"
export * from "./user-management-details.vue?vue&type=script&lang=js&"
import style0 from "./user-management-details.vue?vue&type=style&index=0&id=3817dede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3817dede",
  null
  
)

export default component.exports